import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  color: ${({ theme }) => theme.colors.interactive};
  text-shadow: ${({ theme }) => theme.colors.interactive} 0 0 0.4rem;
  font-size: 5rem;
  line-height: normal;
  font-weight: 300;
  text-transform: uppercase;

  > span {
    color: ${({ theme }) => theme.colors.heroForeground};
    text-shadow: ${({ theme }) => theme.colors.heroForeground} 0 0 0.4rem;

    h1 {
      display: inline-block;
      margin: 0 0 ${({ noMargin }) => (noMargin ? 0 : 3)}rem;
      font-size: 5rem;
    }
  }

  @media screen and (max-width: 800px) {
    font-size: 3rem;

    > span h1 {
      font-size: 3rem;
    }
  }
`

const HeroTitle = ({ children, useH1, noMargin }) => (
  <Container className="heading-font-family" noMargin={noMargin}>
    IOHK |{' '}
    <span>
      {useH1 && <h1 className="heading-font-family">{children}</h1>}
      {!useH1 && children}
    </span>
  </Container>
)

HeroTitle.propTypes = {
  children: PropTypes.node.isRequired,
  useH1: PropTypes.bool,
  noMargin: PropTypes.bool
}

export default HeroTitle
